// extracted by mini-css-extract-plugin
export var forgotPassword = "index-module--forgotPassword--ED3s-";
export var image = "index-module--image--LiUqC";
export var inputField = "index-module--inputField--x5GB-";
export var login = "index-module--login--OB+vq";
export var modal = "index-module--modal--CSFyU";
export var modalButton = "index-module--modalButton--NP5gE";
export var modalOverlay = "index-module--modalOverlay--MqmNt";
export var newAccount = "index-module--newAccount--vr6PD";
export var singInBtn = "index-module--singInBtn--LaKHD";